var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "items-list--item" },
    [
      _vm.isListTypeCustomer
        ? _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Job")
                ]),
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.listItem.jobProfile.info) + "\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "3" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Person")
                ]),
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.listItem.disclosedData.nameWithSalutation) +
                    "\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "3" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Kontaktdaten")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("IconLink", {
                      attrs: {
                        text: _vm.listItem.email,
                        icon: "email",
                        href: "mailto:" + _vm.listItem.email,
                        "with-arrow": false
                      }
                    }),
                    _vm._v(" "),
                    _c("IconLink", {
                      staticClass: "mt-1",
                      attrs: {
                        text: _vm.listItem.phone.formatted,
                        icon: "phone",
                        "with-arrow": false,
                        href: "tel:" + _vm.listItem.phone.full
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "2" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Datum")
                ]),
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm._f("fullDateTime")(_vm.listItem.creationDate)) +
                    "\n\t\t"
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isListTypeCustomer
        ? _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Job")
                ]),
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.listItem.jobProfile.info) + "\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "3" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Firma")
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm.listItem.customer.website
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.listItem.customer.website,
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.listItem.customer.website) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _c("span", [
                        _vm._v(_vm._s(_vm.listItem.customer.companyName))
                      ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.listItem.customer.nameWithSalutation) +
                      " (" +
                      _vm._s(_vm.listItem.customer.role) +
                      ")"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "3" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Kontaktdaten")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("IconLink", {
                      attrs: {
                        text: _vm.listItem.customer.email,
                        icon: "email",
                        href: "mailto:" + _vm.listItem.customer.email,
                        "with-arrow": false
                      }
                    }),
                    _vm._v(" "),
                    _c("IconLink", {
                      staticClass: "mt-1",
                      attrs: {
                        text: _vm.listItem.customer.phone.formatted,
                        icon: "phone",
                        "with-arrow": false,
                        href: "tel:" + _vm.listItem.customer.phone.full
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "2" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Datum")
                ]),
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm._f("fullDateTime")(_vm.listItem.creationDate)) +
                    "\n\t\t"
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }